<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M2 6.625V10.9436C2.82931 10.2013 3.92445 9.75 5.125 9.75H20.75C21.9506 9.75 23.0457 10.2013 23.875 10.9436V9.75C23.875 8.02411 22.4759 6.625 20.75 6.625H15.1472C14.94 6.625 14.7413 6.54269 14.5948 6.39618L12.3851 4.18647C11.9455 3.74693 11.3494 3.5 10.7278 3.5H5.125C3.39911 3.5 2 4.89911 2 6.625ZM23.875 19.125C23.875 20.8509 22.4759 22.25 20.75 22.25H5.125C3.39911 22.25 2 20.8509 2 19.125V14.4375C2 12.7116 3.39911 11.3125 5.125 11.3125H20.75C22.4759 11.3125 23.875 12.7116 23.875 14.4375V19.125ZM18.6201 13.8153C18.6976 13.7636 18.7986 13.7636 18.8761 13.8153L21.6453 15.6615C21.7514 15.7322 21.78 15.8754 21.7093 15.9815C21.6386 16.0875 21.4953 16.1162 21.3893 16.0455L18.7481 14.2847L16.1068 16.0455C16.0008 16.1162 15.8575 16.0875 15.7868 15.9815C15.7161 15.8754 15.7448 15.7322 15.8508 15.6615L18.6201 13.8153ZM21.2865 16.2635V19.315H21.5173C21.6447 19.315 21.748 19.4183 21.748 19.5458C21.748 19.6732 21.6447 19.7766 21.5173 19.7766H15.9788C15.8514 19.7766 15.748 19.6732 15.748 19.5458C15.748 19.4183 15.8514 19.315 15.9788 19.315H16.2096V16.2635C16.2096 16.1498 16.2923 16.0531 16.4046 16.0355C17.1683 15.9157 17.951 15.8535 18.748 15.8535C19.5451 15.8535 20.3278 15.9157 21.0915 16.0355C21.2038 16.0531 21.2865 16.1498 21.2865 16.2635ZM18.9788 17.0073C18.9788 16.8799 18.8755 16.7766 18.748 16.7766C18.6206 16.7766 18.5173 16.8799 18.5173 17.0073V19.0843C18.5173 19.2117 18.6206 19.315 18.748 19.315C18.8755 19.315 18.9788 19.2117 18.9788 19.0843V17.0073ZM19.9019 16.7766C20.0293 16.7766 20.1327 16.8799 20.1327 17.0073V19.0843C20.1327 19.2117 20.0293 19.315 19.9019 19.315C19.7744 19.315 19.6711 19.2117 19.6711 19.0843V17.0073C19.6711 16.8799 19.7744 16.7766 19.9019 16.7766ZM17.825 17.0073C17.825 16.8799 17.7217 16.7766 17.5942 16.7766C17.4668 16.7766 17.3634 16.8799 17.3634 17.0073V19.0843C17.3634 19.2117 17.4668 19.315 17.5942 19.315C17.7217 19.315 17.825 19.2117 17.825 19.0843V17.0073ZM19.0942 15.1612C19.0942 15.3524 18.9392 15.5073 18.748 15.5073C18.5569 15.5073 18.4019 15.3524 18.4019 15.1612C18.4019 14.97 18.5569 14.815 18.748 14.815C18.9392 14.815 19.0942 14.97 19.0942 15.1612Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgCompanyDirectory',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>